import { Component, Input, SimpleChanges } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { EChartsOption } from 'echarts';
import { NgxEchartsDirective } from 'ngx-echarts';
import { EnergyItem } from '../../data-access/group-analysis.interface';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'lib-energy-distribution',
  standalone: true,
  imports: [MatCardModule, NgxEchartsDirective, TranslateModule],
  templateUrl: './energy-distribution.component.html',
  styleUrl: './energy-distribution.component.css',
})
export class EnergyDistributionComponent {
  @Input() items: EnergyItem[] = [];
  @Input() title: string = '';

  chartOption: EChartsOption = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.createChartOption();
    }
  }

  private createChartOption(): void {
    const totalEnergy = this.items.reduce(
      (total, item) => total + Number(item.energy || 0),
      0,
    );
    this.chartOption = {
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} kWh ({d}%)',
      },
      legend: {
        type: 'scroll',
        bottom: 0,
        left: 'center',
        icon: 'roundRect',
      },
      series: [
        {
          name: 'Energy',
          type: 'pie',
          radius: ['38%', '65%'],
          center: ['50%', '43%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            formatter: '{b}\n{d}%',
          },
          labelLine: {
            length: 12,
            length2: 24,
          },
          data: this.items.map((item) => ({
            name: item.name,
            value: item.energy,
            itemStyle: {
              color: item.hexColor,
            },
          })),
        },
      ],
      graphic: [
        {
          type: 'text',
          left: 'center',
          top: '35%',
          style: {
            text: totalEnergy.toLocaleString('en-US'),
            fontSize: 24,
            fontWeight: 600,
            fill: '#0c0e28',
          },
        },
        {
          type: 'text',
          left: 'center',
          top: '45%',
          style: {
            text: 'kWh',
            fontSize: 13,
            fill: '#6b7280',
          },
        },
      ],
    };
  }
}
